import Box from '@mui/material/Box';
import { Order, OrderStatus } from '../../../../models';
import { OrderSummarize } from './OrderSummarize';
import { OrderDetails } from './OrderDetails';
import { ContactSupportText } from '../../../../components';
import { Panel } from '../../../../components/common/Panel';

export const OrderInfo = ({ order, actionItems }: {
  order: Order,
  actionItems?: React.ReactNode,
}) => (
  <Panel
    id={`order-${order.id}`}
    sx={theme => ({
      margin: theme.spacing(3, 0),
    })}
    border
  >
    {/* Order Summarize */}
    <OrderSummarize order={order} />

    {/* Order Details */}
    <OrderDetails order={order} />
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginLeft: 16,
      marginRight: 16,
    }}
    >
      {order.status === OrderStatus.PENDING ? <ContactSupportText /> : <div />}
      {actionItems && (
        <Box
          id="order-action-items"
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          paddingY={2}
          right={0}
        >
          {actionItems}
        </Box>
      )}
    </div>
  </Panel>
);
